import { render, staticRenderFns } from "./TeacherEditForm.vue?vue&type=template&id=7c3ce884&"
import script from "./TeacherEditForm.vue?vue&type=script&lang=js&"
export * from "./TeacherEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports